import handleSagaError from '../../redux/handleSagaError';
import { apiClient } from '../../utils';

const sentAtInvoice = async ({ orderId, sentType, dtc }) =>
  apiClient
    .post('/merchant/order/sentAt', { data: { orderId, sentType, dtc } })
    .then(({ result }) => result)
    .catch(handleSagaError);

export { sentAtInvoice };
